<template>
  <div class="account-box">
    <h1 class="title">获取access_key</h1>
    <div class="access-box">
      <span>电子邮件：</span>
      <el-input v-model="email" v-if="isEdit"></el-input>
      <span v-else>{{email}}</span>
    </div>
    <el-button type="primary" size="small" v-if="isEdit" @click="submit">提交</el-button>
    <el-button size="small" v-else @click="del">删除</el-button>
    <p class="desc">邮箱变更记录</p>
    <el-table :data="recordList" stripe>
      <el-table-column label="邮箱" prop="email"></el-table-column>
      <el-table-column label="小米ID" prop="xiaomiId"></el-table-column>
      <el-table-column label="操作" prop="operation"></el-table-column>
      <el-table-column label="操作时间" prop="operationTime.time" :formatter="formatDate"></el-table-column>
    </el-table>
  </div>
</template>
<script>
  import axios from 'common/axios.js';
  import {DateUtils} from 'common/utils.js';
  export default {
    name: 'account',
    data() {
      return {
        email: '',
        isEdit: true,
        recordList: []
      };
    },
    created() {
      this.init();
      this.getList();
    },
    methods: {
      formatDate(row, column, cellValue) {
        return cellValue ? DateUtils.format(cellValue, 'yyyy-MM-dd HH:mm') : '';
      },
      async init() {
        const {data: {result}} = await axios.get('/v2/openapi/get');
        if (result) {
          this.isEdit = false;
          this.email = result.email;
        } else {
          this.isEdit = true;
        }
      },
      async getList() {
        const {data: {result}} = await axios.get('/v2/openapi/list_record');
        this.recordList = result || [];
      },
      async submit() {
        if (!this.email.trim()) {
          this.$message.error('邮件不能为空');
          return;
        }
        if (!/^\s*\w+(?:\.{0,1}[\w-]+)*@[a-zA-Z0-9]+(?:[-.][a-zA-Z0-9]+)*\.[a-zA-Z]+\s*$/ig.test(this.email)) {
          this.$message.error('邮件格式不正确');
          return;
        }
        const {data: {result}} = await axios.get('/v2/openapi/update', {params: {email: this.email}});
        if (result) {
          this.$message.success('邮箱绑定成功，请及时查阅邮件。');
          this.isEdit = false;
          this.getList();
        }
      },
      del() {
        this.$confirm('是否删除？删除后原邮箱获取的secretKey将失效。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const {data: {result}} = await axios.get('/v2/openapi/delete');
          if (result) {
            this.getList();
            this.isEdit = true;
            this.email = '';
          }
        }).catch(() => {});
      }
    }
  };
</script>
<style lang="scss">
  .account-box {
    height: 100%;
    padding: 36px;
    margin-bottom: 40px;
    background-color: #fff;
    border: 1px solid #ddd;
    .title {
      font-size: 20px;
    }
    .access-box {
      margin-bottom: 36px;
      .el-input {
        display: inline-block;
        width: 400px;
      }
    }
    .desc {
      padding: 30px 0;
    }
    .el-table {
      th {
        background-color: #f5f7fa;
      }
    }
  }
</style>